import cookiejs from "cookiejs";
import config from "@core/config/app.config.js";

export const setCookie = (key, value, num) => {
  cookiejs(key, value, num);
};

export const setCurrentAppCookie = (appName, expiry) => {
  setCookie(config.CURRENT_APP_COOKIE_KEY, appName, {
    expires: expiry,
    path: "/",
    domain: "maropost.com",
  });
};
